/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import Icons from "components/icons"
import Img from "gatsby-image"
import { kebabCase } from "lodash"
import { Link } from "gatsby"

function BlogBase({ data, provider }) {
  const createMarkup = data => {
    return { __html: data }
  }
  //const value = provider == 'blog' ? data.markdownRemark: data;

  return (
    <main id="blog">
      <h1 className="md-heading ">
        {provider === "blog" ? `${data.frontmatter.title}` : `${data.title}`}
      </h1>
      <h2 className="sm-heading ">
        {provider === "blog"
          ? `${data.frontmatter.description} `
          : `Technologies: ${data.tech}`}
      </h2>
      <span className="blog-info">
        {provider === "blog" ? (
          <li>
            <i className="fa fa-calendar fa-2x"> </i> {data.frontmatter.date} ~{" "}
            {data.frontmatter.read}
          </li>
        ) : (
          <li>
            <i className="fa fa-calendar fa-2x"> </i> {data.date_time}
          </li>
        )}

        {provider === "blog" ? (
          <li>
            {" "}
            <i className="fa fa-tag fa-2x"></i>
            {data.frontmatter.tags.map((tag, index) => (
              <Link
                className="tag tag-link"
                to={`/tags/${kebabCase(tag)}/`}
                key={index}
              >
                {tag.toUpperCase()}
                {index + 1 === data.frontmatter.tags.length ? "" : ","}
              </Link>
            ))}
          </li>
        ) : (
          <li>
            <i className="fa fa-comment fa-2x"></i> ~ {data.quote} ~{" "}
            {data.quote_au_da}{" "}
          </li>
        )}
      </span>
      <div className="blog-content">
        <div className="hd-image">
          {provider === "blog" ? (
            <Img
              fluid={data.frontmatter.image.childImageSharp.fluid}
              alt={data.title}
            />
          ) : (
            <Img fluid={data.image.childImageSharp.fluid} alt={data.title} />
          )}
        </div>
        <article className="content">
          {provider === "blog" ? (
            <div dangerouslySetInnerHTML={createMarkup(data.html)} />
          ) : (
            <div dangerouslySetInnerHTML={createMarkup(data.content)} />
          )}
        </article>
      </div>
      <Icons />
    </main>
  )
}

export default BlogBase
